import { render, staticRenderFns } from "./DevelopersCn.vue?vue&type=template&id=677e4519&scoped=true&"
import script from "./DevelopersCn.vue?vue&type=script&lang=js&"
export * from "./DevelopersCn.vue?vue&type=script&lang=js&"
import style0 from "./DevelopersCn.vue?vue&type=style&index=0&id=677e4519&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677e4519",
  null
  
)

export default component.exports